export const recycleWrappingPaperData = [
  {
    Question: `Can you show me how to recycle wrapping paper?`,
    Answer: `Avoid recycling ribbons & foil in your WM container. Check out our video below for more context.`,
  },
]
